// extracted by mini-css-extract-plugin
module.exports = {"table-options":"OptionsRow_table-options__3pDPg","restricted":"OptionsRow_restricted__oV48J"};